<template>
    <Card>
        <template v-slot:header>
            <h2>顾客分布特征</h2>
        </template>
        <div class="card-content">
            <div class="chart-big" ref="chart">
                <div class="total-line">
                    <div class="img-block" style="margin-left: 50px">
                        <img src="../../styles/imgs/man.png" />
                        <br />
                        <br />
                        <span>男士占比 35%</span>
                    </div>
                    <div class="img-block" style="margin-right: 50px">
                        <img src="../../styles/imgs/woman.png" />
                        <br />
                        <br />
                        <span>女士占比 65%</span>
                    </div>
                </div>
                <div class="total-line">
                    <div class="color-line">
                        <div class="man" style="width: 35%"></div>
                    </div>
                </div>
            </div>
        </div>
    </Card>
</template>
<script>
export default {
    name: "FlowRank",
    data() {
        return {
            chartObj: null,
        };
    },
    mounted() {},
    methods: {},
};
</script>
<style scoped>
.img-block {
    flex: 1;
    text-align: center;
}
.color-line {
    flex: 1;
    height: 14px;
    background-color: #ffc62e;
    margin: 0px 10px;
    border-radius: 7px;
    overflow: hidden;
}
.color-line .man {
    width: 100%;
    height: 100%;
    float: left;
    background-color: #4bbeff;
}
</style>
